<div class="no-device-container">
  <div class="no-device-info">
    <span>{{ 'doktar_app.home.pest_risk.no_device' | translate }}</span>
  </div>
  @if (foundDevice) {
    <div class="confirm-device-card">
      <div class="confirm-device-header">
        <div class="confirm-device-icon">
          <dk-dynamic-icon [svg_path]="foundDevice.iconURL"></dk-dynamic-icon>
        </div>
        <div class="confirm-device-content">
          <div class="content-title">
            <!--<span>{{ (foundDevice.line ?? '') + ' ' + (foundDevice.model ?? '') }}</span>-->
            <span>{{ foundDevice.name }}</span>
          </div>
          <div class="content-description">
            <span>
              {{ foundDevice.assetId | productIdNormalizer }}
            </span>
          </div>
        </div>
        <div class="confirm-device">
          <p-button
            (onClick)="confirmDevice()"
            [label]="'doktar_app.common.confirm_button' | translate"
            aria-label="confirm-device" />
        </div>
      </div>
      <div class="confirm-device-bottom">
        <span class="content-description">
          {{ foundDevice.location }}
          •
          <span class="status-text" [ngClass]="{ active: foundDevice.statusName == 'Active' }">
            {{ foundDevice.statusName }}
          </span>
        </span>
      </div>
    </div>
  } @else {
    <div class="add-device-card">
      <div class="card-header">
        <div class="add-device">
          <input
            type="text"
            class="add-device-input"
            pInputText
            [placeholder]="'doktar_app.account.devices.add_device_button_placeholder' | translate"
            [(ngModel)]="addDeviceSearchQuery" />
          <dk-button
            (onClick)="searchDevice()"
            [label]="'doktar_app.common.add' | translate"
            [loading]="searchingDevice"
            [disabled]="addDeviceSearchQuery.length === 0"
            aria-label="add-device" />
        </div>
        @if (backendErrorMessage) {
          <div class="error-container">
            <span class="error-text">
              {{ backendErrorMessage }}
            </span>
          </div>
        }
      </div>
      <div class="card-content">
        <div class="content-title">
          <span>{{ 'doktar_app.account.devices.add_device_button_title' | translate }}</span>
        </div>
        <div class="content-description">
          <span>{{ 'doktar_app.account.devices.add_device_button_description' | translate }}</span>
        </div>
      </div>
    </div>
  }

  <div class="contact-sales-card">
    <div class="contact-content">
      <div class="content-title">
        <span>{{ 'doktar_app.common.devices.want_more_title' | translate }}</span>
      </div>
      <div class="content-description">
        <span>{{ 'doktar_app.common.devices.want_more_desc' | translate }}</span>
      </div>
      <dk-button
        [label]="'doktar_app.communications.home.request_callback' | translate"
        severity="secondary"
        aria-label="contact-us"
        class="contact-us-button"
        (onClick)="requestCallback()" />
    </div>
    <div class="contact-illustration">
      <dk-contact-sales-icon inputColor="transparent" />
    </div>
  </div>
</div>

<!-- Select Plantation Modal -->
<dk-select-plants-modal
  #selectPlantationModal
  (selectPlantations)="onPlantationSelected($event)"></dk-select-plants-modal>
